import React, { useEffect, useRef, useCallback } from 'react'
import { createPortal } from 'react-dom'

interface ComponentProps {
  rootId?: string
  rootRef?: React.RefObject<HTMLElement>
}

const Portal: React.FC<ComponentProps> = ({ rootId = 'portal-root', rootRef, children }) => {
  const rootElement = useRef<HTMLElement | null>(null)

  const getRootElement = useCallback(() => {
    let element = rootRef?.current || document.getElementById(rootId)

    if (!element) {
      element = document.createElement('div')
      element.id = rootId
      document.body.appendChild(element)
      rootElement.current = element
    }

    return element
  }, [rootId, rootRef])

  useEffect(() => {
    const root = rootElement.current

    return () => {
      if (root && root.parentNode) {
        root.parentNode.removeChild(root)
      }

      rootElement.current = null
    }
  }, [])

  return createPortal(children, rootElement.current || getRootElement())
}

export default Portal
